import {ActionsThatCanBeCancelled} from '@colonist/game-base-types'
import {ActionState, TurnState} from '@colonist/game-states'
import {ArrayUtils} from '@colonist/utils'
import {TranslationObject} from '@colonist/i18n'

export const getTranslationObjectForClickState = (isMyTurn: boolean, actionState: ActionState, turnState: TurnState): TranslationObject | undefined => {
    if(!isMyTurn) return {key: 'strings:game.errors.notYourTurn'}
    if(!ArrayUtils.elementInArray(ActionsThatCanBeCancelled.actions, actionState)) return {key: 'strings:game.errors.finishCurrentAction'}
    if(turnState == TurnState.SpecialBuildPhase) return {key: 'strings:game.errors.tradingDisabled'}
    if(turnState != TurnState.Turn) return {key: 'strings:game.errors.finishCurrentAction'}

    return undefined
}
